export default __webpack_public_path__ + "static/media/quote.13c03e55.svg";